export default import.meta.ROLLDOWN_FILE_URL_yOiWtFL26e7mPTEYtqos8A